import { gql } from "@apollo/client";export default gql`mutation deleteChapter($id: Int!) {
    deleteChapter: delete_group_by_pk(id: $id) {
        id
    }
}
`;
